<template>
    <span class="text-danger" v-if="mostrarBtn">
        <i
            class="fa fa-times-circle fa-lg icon-button mr-1"
            title="Reprovar"
            @click.stop="confirmarReprovar()"
        ></i>
    </span>
</template>

<script>
import ComprometimentosServicos from './ComprometimentosServicos2'
import { comprometimentoStatus } from './ComprometimentoStatus'
import { comprometimentoSituacao } from './ComprometimentoSituacao'

export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarReprovar() {
            this.$swal({
                title: 'Reprovar Serviço',
                html: `Confirma a reprovação do serviço <b>${this.comprometimento.idComprometimento}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a justificativa`,
                inputValidator: value => {
                    if (!value) {
                        return `A justificativa é obrigatória'`
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovar(result.value)
                }
            })
        },

        reprovar(justificativa) {
            this.$store.dispatch('addRequest')
            ComprometimentosServicos
                .reprovarComprometimento(
                    {
                        idComprometimento: this.comprometimento.idComprometimento,
                        justificativa: justificativa

                    })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Serviço reprovado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obter-atualizacao')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.comprometimento.status == comprometimentoStatus.APROVADA 
                && this.comprometimento.idSituacao != comprometimentoSituacao.VINCULADO_A_UM_PAGAMENTO
                && this.$temAcessoView('CONT-COMPR-14')
            )
        }
    }
}
</script>
